






























































































































































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'
import _ from 'lodash'

// Mixins
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

// Models
import CategoryModel from '@/_models/CategoryModel'

// Interface
import { IPageFilterModel, IDropdownList } from '@/_interfaces'

// Helpers
import { Filter } from '@/_utils/filter'
import { Constant } from '@/_services/constant'
import { CATEGORIES_CSV_FIELD } from '@/_consts/CSVFields'

// Components
import Swatches from 'vue-swatches'
import UserType from '@/components/shared/UserType.vue'
import TablePagination from '@/components/shared/TablePagination.vue'
import NotFound from '@/components/common/NotFound.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'
import ActionButtonsGroup from '@/components/common/buttons/ActionButtonsGroup.vue'
import CategoryEditModal from './modals/CategoryEditModal.vue'
import ImportCSVModalLayout from '@/components/common/modals/ImportCSVModalLayout.vue'

@Component({
  components: {
    Swatches,
    UserType,
    NotFound,
    TablePagination,
    DropdownSearch,
    CategoryEditModal,
    ActionButtonsGroup,
    ImportCSVModalLayout,
  },
  computed: {
    ...mapGetters('categories', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('categories', {
      canDelete: 'canDelete',
    }),
  },
  filters: {},
})
export default class CategoryList extends mixins(TableSortMixin) {
  canEdit!: () => boolean
  canDelete!: () => boolean

  // data
  filterUtilTableSort: any = new Filter('filter_category_list_table_sort')
  filterUtilPage: any = new Filter('filter_categorylist_page')
  pageFilters: IPageFilterModel = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'name',
    searchQuery: '',
  }
  numofPage: number = 1
  selected: any = {}
  isFormModalActive: boolean = false
  isImportCsvModalActive: boolean = false
  Constant: any = Constant

  isNew: boolean = false

  filedNameLUT: any = {
    _id: 'UUID',
    name: 'label.category_name',
    color: 'label.color',
    user_type: 'label.type',
    category_1: 'label.category_1',
    category_2: 'label.category_2',
    category_3: 'label.category_3',
  }

  csvFields: string[] = CATEGORIES_CSV_FIELD

  dropdownList: IDropdownList[] = [
    {
      value: 'name',
      label: this.$t('label.name').toString(),
    },
    {
      value: 'category_1',
      label: this.$t('label.category_1').toString(),
    },
    {
      value: 'category_2',
      label: this.$t('label.category_2').toString(),
    },
    {
      value: 'category_3',
      label: this.$t('label.category_3').toString(),
    },
  ]

  // computed
  get categories(): CategoryModel[] {
    const categories = this.$store.state.categories.all.items
    this.numofPage = Math.ceil(categories.length / this.pageFilters.perPage)

    return categories
  }

  get isLoading(): boolean {
    return this.$store.state.categories.loading
  }

  get filteredData(): CategoryModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.categories) {
      return []
    }

    return this.categories.filter((item: any): boolean => {
      return (
        String(item[targetField]).toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  handleChangeCategoryColor(data): void {
    this.$store.dispatch('categories/updateOne', data).then(() => {
      this.$buefy.toast.open(this.$t('messages.update_success') as string)
    })
  }

  handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
    this.isNew = false
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new CategoryModel()
    this.isNew = true
  }

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return false
      }
      if (this.isNew) {
        // add item
        this.$store.dispatch('categories/addOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store.dispatch('categories/updateOne', this.selected).then(() => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.update_success') as string)
        })
      }
    })
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  confirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.$store.dispatch('categories/hasRefs', this.selected).then(result => {
          if (result.has_reference) {
            this.confirmForceDelete(data)
          } else {
            this.processDelete(data)
          }
        })
      },
    })
  }

  confirmForceDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.has_refs_data_are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      },
    })
  }

  processDelete(data): void {
    this.selected = data
    const index = this.categories.indexOf(this.selected)
    this.$store.dispatch('categories/deleteOne', this.selected).then(() => {
      this.selected = {}
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.$store.dispatch('categories/getAll')
  }
}
